function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1086_2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M165 0H0V165H165V0Z",
  fill: "#DDE9AF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.0384 24.5949C26.0105 30.5417 38.6002 32.4107 32.5955 25.7188C31.8114 24.7106 30.3234 23.7697 29.0384 24.5949V24.5949Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.5493 34.6854C41.0159 28.1755 28.3543 29.4711 35.8248 34.4742C36.8335 35.2577 38.5076 35.8023 39.5493 34.6854V34.6854Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.0916 29.4368C44.612 25.6874 34.4839 17.9787 36.5173 26.7369C36.718 27.9982 37.5678 29.54 39.0916 29.4368V29.4368Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.9491 137.012C23.3549 135.987 25.5006 148.533 29.9892 140.742C30.703 139.683 31.1336 137.976 29.9491 137.012Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.8684 127.953C18.5524 132.706 24.3068 121.353 16.0595 124.933C14.8551 125.359 13.492 126.473 13.8684 127.953Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.166 123.678C127.757 121.819 128.281 134.535 133.729 127.383C134.572 126.424 135.217 124.786 134.166 123.678Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.4441 14.0532C79.9702 15.4458 78.5306 2.79958 73.6129 10.3266C72.8409 11.344 72.3155 13.0243 73.4441 14.0532V14.0532Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.875 131.664C123.945 138.008 134.162 130.418 125.183 129.941C123.916 129.783 122.199 130.172 121.875 131.664Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.5778 60.1481C85.401 56.8891 75.9763 48.3352 77.2462 57.2361C77.3373 58.5101 78.0509 60.1194 79.5778 60.1481Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.0518 81.6118C49.3932 87.8609 59.2733 79.8371 50.2827 79.747C49.0096 79.6445 47.3109 80.1067 47.0518 81.6118Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.7426 133.048C26.8172 127.05 17.7455 135.977 26.7037 135.212C27.9808 135.192 29.6278 134.571 29.7426 133.048Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.942 34.8037C40.8539 37.5363 49.4874 46.8884 49.0077 37.91C49.0293 36.633 48.4605 34.967 46.942 34.8037Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.8915 37.7349C32.8411 43.114 40.1727 32.71 31.4951 35.0633C30.242 35.3102 28.7324 36.216 28.8915 37.7349V37.7349Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.0033 35.1985C49.4849 33.6114 42.6842 22.853 41.5331 31.77C41.281 33.0221 41.5396 34.7635 43.0033 35.1985Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.3743 39.4282C40.05 44.9977 47.8925 34.9732 39.1082 36.89C37.8443 37.074 36.2914 37.9032 36.3743 39.4282Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.625 112.676C126.937 106.133 114.309 107.729 121.896 112.553C122.923 113.313 124.61 113.817 125.625 112.676Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M136.747 110.756C142.236 106.96 132.042 99.3379 134.15 108.078C134.362 109.338 135.225 110.872 136.747 110.756Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.046 117.669C139.677 112.863 128.179 107.404 131.972 115.556C132.428 116.749 133.577 118.083 135.046 117.669Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.335 113.81C122.021 118.902 133.844 123.615 129.538 115.722C129.007 114.56 127.775 113.302 126.335 113.81Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.127 116.259C118.187 122.866 130.704 120.56 122.856 116.171C121.788 115.471 120.076 115.063 119.127 116.259V116.259Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.389 118.209C134.725 117.851 138.119 130.118 141.803 121.916C142.407 120.791 142.664 119.049 141.389 118.209V118.209Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.289 121.014C140.748 119.692 142.325 132.322 147.161 124.742C147.922 123.716 148.429 122.031 147.289 121.014Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.112 116.512C144.785 109.847 132.93 114.48 141.466 117.304C142.648 117.79 144.406 117.867 145.112 116.512Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.119 120.961C154.167 114.61 141.44 114.757 148.428 120.415C149.362 121.286 150.98 121.979 152.119 120.961Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.314 110.469C133.683 112.46 133.421 99.735 127.827 106.774C126.964 107.716 126.285 109.34 127.314 110.469Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.9358 33.883C31.3029 27.3512 18.6626 28.8403 26.2086 33.7287C27.2291 34.4967 28.9113 35.0156 29.9358 33.883V33.883Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.974 127.303C128.917 120.918 116.194 121.276 123.275 126.817C124.223 127.673 125.853 128.339 126.974 127.303Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.4734 36.8362C92.3944 32.3287 81.2595 26.1639 84.5362 34.5364C84.917 35.7555 85.9806 37.1584 87.4734 36.8362Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.019 26.3069C107.077 19.9592 94.3496 20.0866 101.329 25.7546C102.262 26.6274 103.879 27.3234 105.019 26.3069Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.4432 93.1203C74.0568 99.648 86.7014 98.1962 79.17 93.2856C78.1518 92.5146 76.4711 91.9907 75.4432 93.1203Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.0653 79.6693C50.0933 76.8064 41.2608 67.6423 41.9333 76.608C41.939 77.8852 42.5437 79.5387 44.0653 79.6693Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.1266 82.0692C36.6708 85.9118 46.9278 93.4475 44.7463 84.725C44.5243 83.4673 43.6484 81.9401 42.1266 82.0692Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.2948 80.6748C30.6322 81.0537 35.3578 92.8718 38.1152 84.3139C38.5914 83.1288 38.6549 81.3694 37.2948 80.6748Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.6532 127.692C27.1464 121.191 16.3047 127.858 25.2067 129.12C26.4556 129.387 28.2001 129.151 28.6532 127.692Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.0612 77.4539C41.2019 70.7823 29.0521 74.5738 37.3693 77.9888C38.5138 78.5557 40.2628 78.7559 41.0612 77.4539Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.0161 90.6679C19.5955 89.5533 13.59 78.3314 11.7975 87.1421C11.4556 88.3726 11.5874 90.1282 13.0161 90.6679Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.6294 86.0865C14.6977 80.7966 2.66471 76.6482 7.33895 84.3287C7.92463 85.4637 9.21459 86.6618 10.6294 86.0865Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.6708 140.456C17.3261 143.998 20.3018 131.623 13.1049 137.012C12.0313 137.704 10.9625 139.103 11.6708 140.456Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.1019 129.578C5.71027 131.497 13.0556 141.891 13.7465 132.927C13.9338 131.663 13.5863 129.937 12.1019 129.578Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9559 134.272C21.2578 138.324 25.3707 126.28 17.7039 130.976C16.5707 131.565 15.3764 132.859 15.9559 134.272Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.8259 135.682C15.5265 137.884 23.33 147.939 23.6188 138.953C23.7494 137.682 23.3249 135.974 21.8259 135.682Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.3552 15.6106C68.7509 19.233 78.6998 27.1707 76.8671 18.3685C76.6953 17.1029 75.8809 15.5422 74.3552 15.6106Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.2104 13.6074C63.0071 16.0675 71.2177 25.7931 71.1364 16.8023C71.2146 15.5275 70.7202 13.8378 69.2104 13.6074Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.978 134.805C143.366 128.278 130.721 129.727 138.252 134.639C139.27 135.41 140.95 135.934 141.978 134.805Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1086_2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 165,
  height: 165,
  fill: "white"
})));

var SvgD1 = function SvgD1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgD1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/d_1.9fe4e3cd.svg";
export { ForwardRef as ReactComponent };